import { Header, Content } from '@/components'
import { LayoutProps } from '@/store/types'

function WebLayout( props: MainLayoutProps ) {
    const {
        title,
        children,
    } = props

    return (
        <>
            <Header
                title={ title }
            />
            <div
                className="flex"
                style={{
                    height: '70px',
                    backgroundColor: '#6C788E',
                    color: 'white',
                    fontSize: '20px',
                    fontWeight: 700,
                    alignItems: 'center',
                    marginBottom: '8px',
                    justifyContent: 'center'
                }}
            >
                <span>
                    { title }
                </span>
            </div>
            <Content
                contentPadding="12px"
                fullWidth
            >
                { children && children }
            </Content>
        </>
    )
}

export default WebLayout

export interface MainLayoutProps extends LayoutProps {
    contentWidth?: number
}
